var exports = {
  "k": "container__xNFvwI",
};

module.exports = exports;
